import { defineModule } from '../../manifest.js';
export const manifest = defineModule({
    moduleKey: 'field-service',
    name: 'Field Service',
    description: 'Jobs, scheduling, mobile engineers, parts and completion.',
    kind: 'commercial',
    sellable: true,
    navigationModuleKey: 'field-service',
    features: [
        { key: 'field_service.offline', description: 'Offline-capable mobile job execution' },
        { key: 'field_service.route_optimisation', description: 'Optimised engineer routing' },
    ],
    editions: [
        { code: 'ed_01', description: 'Base edition', features: [], limits: ['user', 'site'] },
        {
            code: 'ed_02',
            description: 'Adds offline working and routing',
            features: ['field_service.offline', 'field_service.route_optimisation'],
            limits: ['user', 'active_user', 'site', 'transaction'],
        },
    ],
    limitTypes: ['user', 'active_user', 'site', 'transaction'],
    meteredEvents: [
    // Declared empty deliberately. This module is REGISTERED, not implemented:
    // what it meters is a decision that belongs to the stage that builds it,
    // and inventing metric keys now would put names into entitlement and
    // billing records before anybody designed them (S4-6).
    ],
    requiredCore: [
        'tenancy',
        'hierarchy',
        'identity',
        'authz',
        'audit',
        'storage',
        'party_master',
        'inventory',
        'workforce_ops',
        'compliance_kernel',
    ],
    optionalModules: ['finance', 'service-support'],
    integrationDeps: [],
    lifecycle: 'proposed',
    commercialRelease: 'later',
    version: 1,
});
//# sourceMappingURL=module.manifest.js.map